import { InjectProperty } from '@jack-henry/frontend-utils/di';
import { NavigationService } from '@treasury/core/navigation';
import { ReportingService } from '@treasury/domain/reports/reports.service';
import { TmContainer } from '@treasury/presentation';
import { arrowBackIcon } from '@treasury/presentation/assets/icons';
import '@treasury/presentation/components/tm-bottom-sheet';
import '@treasury/presentation/components/tm-button';
import '@treasury/presentation/components/tm-context-menu';
import '@treasury/presentation/components/tm-icon';
import '@treasury/presentation/components/tm-list';
import { css, html, nothing } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import '../../dashboard/components/reports-widget';
import { HeaderBarService } from '../../services/jhd-header-bar.service';
import '../partials/report-layout';

export enum ReportActions {
    DOWNLOAD_REPORT = 'Download',
    SAVE_REPORT = 'Save',
    SWITCH_REPORT = 'Switch Report',
}

export const tagName = 'report-container';
@customElement(tagName)
export class ReportContainer extends TmContainer {
    @InjectProperty()
    declare private reportingService: ReportingService;

    @InjectProperty()
    declare private navigationService: NavigationService;

    @InjectProperty()
    declare private headerBarService: HeaderBarService;

    @state()
    private reportListVisible = false;

    @state()
    private isReportingHub = false;

    public render() {
        return html`<div
            class=${classMap({
                'flex flex-row': true,
                'flex-col h-full': !this.deviceService.isDesktop,
            })}
        >
            <div>${this.renderSidebar()}</div>
            <div class="flex-grow">
                <slot
                    @switch-report=${() => {
                        this.reportListVisible = !this.reportListVisible;
                    }}
                ></slot>
                ${this.renderReportEmptyState()}
            </div>
        </div>`;
    }

    protected renderReportEmptyState() {
        if (this.isReportingHub && this.isDesktop) {
            return html`<div
                class="mt-2 mx-2 mb-12 bg-white border-2 border-dashed border-[--border-color] rounded-lg min-h-[70vh] flex items-center justify-center"
            >
                <tm-icon .icon=${arrowBackIcon}></tm-icon
                ><span class="text-lg">&nbsp;Select a report to run</span>
            </div>`;
        }
        return nothing;
    }

    protected async updated() {
        const { params } = await this.navigationService.getRouteData<{
            institution: string;
            type: string;
            id: string;
            action: string;
        }>();
        this.isReportingHub = !params.id;
    }

    private renderSidebar() {
        if (!this.deviceService.isDesktop && !this.isReportingHub) {
            return html`<tm-bottom-sheet
                horizontal
                .open=${this.reportListVisible}
                @close=${() => {
                    this.reportListVisible = false;
                }}
                ><reports-widget
                    .rounded=${false}
                    @report-action-taken=${() => {
                        this.reportListVisible = false;
                    }}
                ></reports-widget
            ></tm-bottom-sheet>`;
        }
        return html`
            <reports-widget
                class=${classMap({
                    'mx-2 my-2 pb-[25px]': this.isDesktop,
                })}
                .rounded=${this.deviceService.isDesktop}
                @report-action-taken=${() => {
                    this.isReportingHub = false;
                }}
            ></reports-widget>
        `;
    }

    public static get styles() {
        return css`
            :host {
                display: block;
                height: 100vh;
            }
        `;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        'report-container': ReportContainer;
    }
}
